import { useMemo } from 'react';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'framework/Icon';

import { EMPTY_FUNCTION } from '../../../../constants';

import { AccordionFilterProps } from './types';

import cn from './AccordionFilter.module.scss';

export const AccordionFilter = ({
  label = '',
  is_expanded = false,
  setToggle = EMPTY_FUNCTION,
  count,
  children,
}: AccordionFilterProps) => {
  const value = useMemo(() => {
    if (count) {
      return `${label} (${count})`;
    }
    return label;
  }, [count, label]);
  return (
    <div className={cn.section}>
      <div className={cn.header} onClick={() => setToggle(!is_expanded)}>
        <p>{value}</p>
        <div className={cn.flex} />
        <Icon icon={is_expanded ? faChevronDown : faChevronRight} width="30px" button />
      </div>
      {is_expanded && <div className={cn.content}>{children}</div>}
    </div>
  );
};
